import { QRCodeSVG } from "qrcode.react";
import bell from "../../assets/img/bell.svg";
import { getCountryCallingCode } from "libphonenumber-js";

const QR_Blank = (props: any) => {
  return (
    <div className="qr-wrap-blank">
      <p className="qr-id" style={{bottom:"-16px",right:"15px",zIndex:1,fontSize:"11px"}}>
        {props.countries[0] === "all"
          ? `No ${props.qr.shortId}`
          : `No ${getCountryCallingCode(props.countries[0])}-${
              props.countries.length
            }-${props.qr.shortId}`}
      </p>      
      <QRCodeSVG
        size={242}
        level="H"
        imageSettings={{
          src: require("../../assets/img/doorvi_round.jpg"),
          height: 35,
          width: 35,
          excavate: true,
        }}
        className="qrcode-bell"
        value={props.value}
      />
    </div>
  );
};

export default QR_Blank;
